import { motion } from "framer-motion";
import { ChefHat } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { BRAND } from "@/lib/brand";
import { resolveImageUrl } from "@/lib/api";

const PHOTOS = BRAND.gastronomyPhotos;
const RATIOS = ["aspect-[3/4]", "aspect-square", "aspect-[4/5]", "aspect-[4/3]", "aspect-[3/4]", "aspect-[5/4]"];

export default function GastronomySection() {
  const { t } = useI18n();
  return (
    <section
      id="gastronomia"
      data-testid="gastronomy-section"
      className="relative py-16 md:py-20 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{t.gastronomy.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] uppercase leading-[1.05]">
            {t.gastronomy.title}
          </h2>
          <div className="mt-5 flex items-center gap-3 text-[#3e664c]">
            <ChefHat size={22} />
            <span className="font-script text-2xl text-[#5daa92]">xef privat</span>
          </div>
          <p className="mt-4 text-[#5C544F] leading-relaxed max-w-md">{t.gastronomy.desc}</p>
          <a
            href="#contacto"
            data-testid="gastronomy-cta"
            className="mt-7 inline-flex items-center gap-3 px-7 py-3 rounded-full bg-[#3e664c] hover:bg-[#2e5949] text-[#fdfcf9] text-sm uppercase tracking-[0.18em] font-medium transition-colors"
          >
            {t.cta.bookDate}
          </a>
        </motion.div>

        <div className="lg:col-span-7 columns-2 md:columns-3 gap-3" data-testid="gastronomy-masonry">
          {PHOTOS.map((url, i) => (
            <motion.div
              key={url}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              data-testid={`gastronomy-photo-${i}`}
              className={`group relative mb-3 break-inside-avoid overflow-hidden rounded-2xl shadow-[0_12px_30px_rgb(28,36,33,0.08)] ${RATIOS[i % RATIOS.length]}`}
            >
              <img
                src={resolveImageUrl(url)}
                alt={`Gastronomia ${i + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
